import { getLocale } from "../runtime";

const da_changemarket = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Vælg land`
};

const en_changemarket = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Select country`
};

const es_changemarket = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Seleccionar país`
};

const fi_changemarket = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Valitse maa`
};

const nb_changemarket = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Velg land`
};

const sv_changemarket = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Välj land`
};

const changemarket = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "da") return da_changemarket(inputs)
	if (locale === "en") return en_changemarket(inputs)
	if (locale === "es") return es_changemarket(inputs)
	if (locale === "fi") return fi_changemarket(inputs)
	if (locale === "nb") return nb_changemarket(inputs)
	if (locale === "sv") return sv_changemarket(inputs)
	return "changeMarket";
};

export { changemarket as "changeMarket" };